<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'CLIENT.CLIENTS_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddClient">
          <button
            (click)="createClient()"
            mat-raised-button
            matTooltip="Create new client"
            color="primary"
            type="button"
          >
            <span class="svg-icon-md" translate="CLIENT.NEW_CLIENT">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Client
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 145px !important"
          class="btn btn-sm btn-light-{{ getItemCssClassByStatus(searchIsActiveSelect) }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect) }} Clients
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client">
            <span
              [matTooltip]="canViewClient(client) ? 'View Client' : null"
              [class.clickable]="canViewClient(client)"
              (click)="viewClientDblclick(client.id, client)"
              >{{ client.first_name ? client.first_name : '' }}
              {{ client.middle_name ? client.middle_name : '' }}
              {{ client.last_name ? client.last_name : '' }}
              {{ client.last_name2 ? client.last_name2 : '' }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.NAME' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'CLIENT.TABLE.NAME' | translate"
                [(ngModel)]="searchNameInput"
              />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.EMAIL' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client">{{ client.email }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.EMAIL' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchEmailInput"
                [placeholder]="'CLIENT.TABLE.EMAIL' | translate"
              />
              <button
                *ngIf="searchEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="clientClass">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.CLASS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client">{{ client.client_class | titlecase }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchClientClass">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.CLASS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchClientClassInput"
                [placeholder]="'CLIENT.TABLE.CLASS' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="COMPANY">Company</mat-option>
                <mat-option value="INDIVIDUAL">Individual</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cellPhone">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.PHONE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client" class="phone-hyper-style"
            >{{ client.cell_phone | phoneFormat }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCellPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchCellPhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'CLIENT.TABLE.PHONE' | translate"
              />
              <button
                *ngIf="searchCellPhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchCellPhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="fax">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.FAX' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client" class="phone-hyper-style"
            >{{ client.fax | phoneFormat }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchFax">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.FAX' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchFaxInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'CLIENT.TABLE.FAX' | translate"
              />
              <button
                *ngIf="searchFaxInput"
                matSuffix
                mat-icon-button
                (click)="searchFaxInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="domain">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.DOMAIN' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client">{{ client.domain }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDomain">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.DOMAIN' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchDomainInput"
                [placeholder]="'CLIENT.TABLE.DOMAIN' | translate"
              />
              <button
                *ngIf="searchDomainInput"
                matSuffix
                mat-icon-button
                (click)="searchDomainInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'CLIENT.TABLE.STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let client">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(client.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(client.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'CLIENT.TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'CLIENT.TABLE.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let client">
            <ng-template ngxPermissionsOnly="canViewClient">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Client"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewClient(client)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditClient">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Client"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editClient(client.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateClient">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Client"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateStatusForClient(client)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteClient">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Client"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteClient(client)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
